if (!customElements.get('juronoid-editorial')) {
  customElements.define('juronoid-editorial', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motionButton = this.querySelector('[data-motion-toggle]');
      this.motionLabel = this.querySelector('[data-motion-label]');
      this.driftItems = [...this.querySelectorAll('[data-drift]')];
      this.visibleItems = new Set();
      this.paused = false;
      this.raf = null;
      this.schedule = () => {
        if (this.raf !== null || this.paused || this.motionQuery.matches || document.hidden) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.visibleItems.forEach(item => {
            const rect = item.getBoundingClientRect();
            const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight));
            item.style.setProperty('--je-drift', `${(progress * Number(item.dataset.drift)).toFixed(2)}px`);
          });
        });
      };
      this.syncMotion = () => {
        const stopped = this.paused || this.motionQuery.matches;
        this.classList.toggle('is-motion-paused', stopped);
        if (this.motionButton) {
          this.motionButton.hidden = this.motionQuery.matches;
          this.motionButton.setAttribute('aria-pressed', String(this.paused));
          this.motionLabel.textContent = this.paused ? this.motionButton.dataset.playLabel : this.motionButton.dataset.pauseLabel;
        }
        if (stopped) this.driftItems.forEach(item => item.style.removeProperty('--je-drift'));
        else this.schedule();
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => entry.isIntersecting ? this.visibleItems.add(entry.target) : this.visibleItems.delete(entry.target));
          this.schedule();
        });
        this.driftItems.forEach(item => this.observer.observe(item));
      } else this.driftItems.forEach(item => this.visibleItems.add(item));
      this.motionButton?.addEventListener('click', () => { this.paused = !this.paused; this.syncMotion(); }, options);
      this.motionQuery.addEventListener('change', this.syncMotion, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, { ...options, passive: true });
      document.addEventListener('visibilitychange', this.schedule, options);
      this.syncMotion();
      const filters = this.querySelector('[data-filters]');
      if (filters) {
        const buttons = [...filters.querySelectorAll('[data-filter]')];
        const articles = [...this.querySelectorAll('[data-article]')];
        const status = this.querySelector('[data-filter-status]');
        buttons.forEach(button => button.addEventListener('click', () => {
          const category = button.dataset.filter;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          let count = 0;
          articles.forEach(article => {
            article.hidden = category !== 'all' && article.dataset.category !== category;
            if (!article.hidden) count += 1;
          });
          if (status) status.textContent = `${status.dataset.countLabel}: ${count}`;
        }, options));
        filters.hidden = false;
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.raf !== null) cancelAnimationFrame(this.raf);
      this.initialized = false;
    }
  });
}
